<mat-card
  appearance="outlined"
  class="avenue-asset-item-container"
  [ngClass]="{ 'selected-asset': isAssetSelected(asset) }"
  >
  <section class="avenue-asset-item-options">
    <mat-radio-button
      [checked]="isAssetSelected(asset)"
      (change)="onSelectAsset($event, asset)"
      >
    </mat-radio-button>

    <div class="options-edit-delete-container">
      @if (canBeEdited(asset)) {
        <button
          mat-icon-button
          aria-label="Performance Activity Can Be Edited Button"
          type="button"
          matTooltip="Edit"
          (click)="$event.stopPropagation(); editAsset(asset)"
          matTooltipShowDelay="1000"
          >
          <mat-icon class="icon" aria-label="Edit">edit</mat-icon>
        </button>
      }

      @if (canBeEdited(asset)) {
        <button
          mat-icon-button
          aria-label="Delete Performance button"
          type="button"
          color="default"
          class="delete-button"
          [matMenuTriggerFor]="removeMenu"
          matTooltip="Delete"
          matTooltipShowDelay="1000"
          (click)="$event.stopPropagation()"
          >
          <mat-icon class="icon" aria-label="Delete">delete </mat-icon>
        </button>
      }
    </div>

    <mat-menu #removeMenu="matMenu" xPosition="before">
      <p mat-menu-item class="margin-0" type="button" disabled>
        <span
          >Permanently Delete
          <span [innerHTML]="asset?.displayName | encodeHTMLEntities"></span
            >?
          </span>
        </p>
        @if (asset) {
          <button
            mat-menu-item type="button" (click)="deleteAsset(asset)">
            <mat-icon color="primary">thumb_up </mat-icon>
            <span>Yes</span>
          </button>
        }
        <button mat-menu-item type="button">
          <mat-icon color="warn">thumb_down </mat-icon>
          <span>No</span>
        </button>
      </mat-menu>
    </section>
    <section class="avenue-asset-item-thumb">
      @if (typeCzech(asset, 'image')) {
        <span class="thumb-wrapper">
          <img
            [src]="mediaUrl$ | async"
            [hidden]="!isMediaUrlLoaded"
            (load)="isMediaUrlLoaded = true"
            alt="Performance Asset Item Image"
            class="asset-image"
            />
          @if (!isMediaUrlLoaded) {
            <div><mat-spinner [diameter]="15"></mat-spinner></div>
          }
        </span>
      }
      @if (typeCzech(asset, 'video')) {
        <span class="thumb-wrapper">
          <div class="video-wrapper">
            <video
              class="video avenue-video"
              playsinline
              muted
              (mouseenter)="playVideo($event)"
              (mouseleave)="pauseVideo($event)"
              [src]="mediaUrl$ | async"
            ></video>
            <div class="playpause">
              <mat-icon>videocam</mat-icon>
              <span class="cdk-visually-hidden">Performance Video Icon</span>
            </div>
          </div>
        </span>
      }
      <div class="avenue-asset-title" [innerHTML]="asset?.displayName | encodeHTMLEntities" [attr.title]="asset?.displayName"></div>
    </section>
  </mat-card>
